import { useQuery } from "@tanstack/react-query";
import { businessLicenseQueryApi } from "@/shared/api/business-license/query";
import { BuyerBusinessLicenseResponse } from "@/shared/api/business-license/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 바이어 사업자등록증 조회 훅 — 바이어 페이지에서는 companyId가 buyer_id다.
// 미등록이면 null이 오는 것이 정상이라 에러로 다루지 않는다.
// 비suspense 쿼리로 두어 호출하는 카드가 자체 로딩만 처리하고 페이지는 멈추지 않게 한다.
// 응답 url이 180초 만료 presigned URL이라, 오래 들고 있다가 열면 만료된다(refetch로 갱신).
const useGetBuyerBusinessLicense = () => {
  const { companyId } = useCompanyIdentity();

  const {
    data: businessLicense,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ["buyer-business-license", companyId],
    queryFn: () =>
      businessLicenseQueryApi.getBuyerBusinessLicense(companyId as number),
    // toCamelKeyObject는 null을 그대로 돌려주므로 미등록 응답도 안전하다.
    select: (data) =>
      toCamelKeyObject(data) as BuyerBusinessLicenseResponse | null,
    enabled: Boolean(companyId),
  });

  return { businessLicense, isPending, refetch };
};

export default useGetBuyerBusinessLicense;
